import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import { Mutation } from 'react-apollo'

const SelectBelongsTo = ({
  mutation,
  afterMutate,
  buildMutationOptions = () => ({}),
  ...props
}) => (
  <Mutation mutation={mutation}>
    {mutate => (
      <Fragment>
        <h5>Select one</h5>
        <PaginatedConnectionTable
          manage
          onRowClick={(e, row) => {
            mutate(buildMutationOptions(row))
            afterMutate()
          }}
          {...props}
        />
      </Fragment>
    )}
  </Mutation>
)

export default SelectBelongsTo



// WEBPACK FOOTER //
// ./src/components/BelongsTo/Select.js